import { j as D } from "./jsx-runtime-3tyXYecC.mjs";
import h, { Component as S } from "react";
import { P as f } from "./index-BpaEWJM0.mjs";
import { m as U } from "./tss-DN0acMKN.mjs";
import { M as A, d as N } from "./constants-CnFYFetN.mjs";
var F = Object.assign || function(a) {
  for (var i = 1; i < arguments.length; i++) {
    var r = arguments[i];
    for (var e in r)
      Object.prototype.hasOwnProperty.call(r, e) && (a[e] = r[e]);
  }
  return a;
}, q = /* @__PURE__ */ function() {
  function a(i, r) {
    for (var e = 0; e < r.length; e++) {
      var t = r[e];
      t.enumerable = t.enumerable || !1, t.configurable = !0, "value" in t && (t.writable = !0), Object.defineProperty(i, t.key, t);
    }
  }
  return function(i, r, e) {
    return r && a(i.prototype, r), e && a(i, e), i;
  };
}();
function $(a, i) {
  var r = {};
  for (var e in a)
    i.indexOf(e) >= 0 || Object.prototype.hasOwnProperty.call(a, e) && (r[e] = a[e]);
  return r;
}
function B(a, i) {
  if (!(a instanceof i))
    throw new TypeError("Cannot call a class as a function");
}
function K(a, i) {
  if (!a)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return i && (typeof i == "object" || typeof i == "function") ? i : a;
}
function G(a, i) {
  if (typeof i != "function" && i !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof i);
  a.prototype = Object.create(i && i.prototype, { constructor: { value: a, enumerable: !1, writable: !0, configurable: !0 } }), i && (Object.setPrototypeOf ? Object.setPrototypeOf(a, i) : a.__proto__ = i);
}
var z = function(a) {
  G(i, a);
  function i() {
    var r;
    B(this, i);
    for (var e = arguments.length, t = Array(e), o = 0; o < e; o++)
      t[o] = arguments[o];
    var n = K(this, (r = i.__proto__ || Object.getPrototypeOf(i)).call.apply(r, [this].concat(t)));
    return n.state = {}, n.styles = {
      ellipsis: {
        position: "fixed",
        visibility: "hidden",
        top: 0,
        left: 0
      }
    }, n.elements = {}, n.onResize = n.onResize.bind(n), n.onTruncate = n.onTruncate.bind(n), n.calcTargetWidth = n.calcTargetWidth.bind(n), n.measureWidth = n.measureWidth.bind(n), n.getLines = n.getLines.bind(n), n.renderLine = n.renderLine.bind(n), n;
  }
  return q(i, [{
    key: "componentDidMount",
    value: function() {
      var e = this.elements.text, t = this.calcTargetWidth, o = this.onResize, n = document.createElement("canvas");
      this.canvasContext = n.getContext("2d"), t(function() {
        e && e.parentNode.removeChild(e);
      }), window.addEventListener("resize", o);
    }
  }, {
    key: "componentDidUpdate",
    value: function(e) {
      this.props.children !== e.children && this.forceUpdate(), this.props.width !== e.width && this.calcTargetWidth();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      var e = this.elements.ellipsis, t = this.onResize, o = this.timeout;
      e.parentNode.removeChild(e), window.removeEventListener("resize", t), window.cancelAnimationFrame(o);
    }
    // Shim innerText to consistently break lines at <br/> but not at \n
  }, {
    key: "innerText",
    value: function(e) {
      var t = document.createElement("div"), o = "innerText" in window.HTMLElement.prototype ? "innerText" : "textContent";
      t.innerHTML = e.innerHTML.replace(/\r\n|\r|\n/g, " ");
      var n = t[o], c = document.createElement("div");
      return c.innerHTML = "foo<br/>bar", c[o].replace(/\r\n|\r/g, `
`) !== `foo
bar` && (t.innerHTML = t.innerHTML.replace(/<br.*?[\/]?>/gi, `
`), n = t[o]), n;
    }
  }, {
    key: "onResize",
    value: function() {
      this.calcTargetWidth();
    }
  }, {
    key: "onTruncate",
    value: function(e) {
      var t = this.props.onTruncate;
      typeof t == "function" && (this.timeout = window.requestAnimationFrame(function() {
        t(e);
      }));
    }
  }, {
    key: "calcTargetWidth",
    value: function(e) {
      var t = this.elements.target, o = this.calcTargetWidth, n = this.canvasContext, c = this.props.width;
      if (t) {
        var l = c || // Floor the result to deal with browser subpixel precision
        Math.floor(t.parentNode.getBoundingClientRect().width);
        if (!l)
          return window.requestAnimationFrame(function() {
            return o(e);
          });
        var s = window.getComputedStyle(t), p = [s["font-weight"], s["font-style"], s["font-size"], s["font-family"]].join(" ");
        n.font = p, this.setState({
          targetWidth: l
        }, e);
      }
    }
  }, {
    key: "measureWidth",
    value: function(e) {
      return this.canvasContext.measureText(e).width;
    }
  }, {
    key: "ellipsisWidth",
    value: function(e) {
      return e.offsetWidth;
    }
  }, {
    key: "trimRight",
    value: function(e) {
      return e.replace(/\s+$/, "");
    }
  }, {
    key: "getLines",
    value: function() {
      for (var e = this.elements, t = this.props, o = t.lines, n = t.ellipsis, c = t.trimWhitespace, l = this.state.targetWidth, s = this.innerText, p = this.measureWidth, O = this.onTruncate, x = this.trimRight, u = [], y = s(e.text), m = y.split(`
`).map(function(C) {
        return C.split(" ");
      }), T = !0, d = this.ellipsisWidth(this.elements.ellipsis), b = 1; b <= o; b++) {
        var v = m[0];
        if (v.length === 0) {
          u.push(), m.shift(), b--;
          continue;
        }
        var w = v.join(" ");
        if (p(w) <= l && m.length === 1) {
          T = !1, u.push(w);
          break;
        }
        if (b === o) {
          for (var j = v.join(" "), E = 0, R = j.length - 1; E <= R; ) {
            var k = Math.floor((E + R) / 2), P = j.slice(0, k + 1);
            p(P) + d <= l ? E = k + 1 : R = k - 1;
          }
          var W = j.slice(0, E);
          if (c)
            for (W = x(W); !W.length && u.length; ) {
              var _ = u.pop();
              W = x(_);
            }
          w = h.createElement(
            "span",
            null,
            W,
            n
          );
        } else {
          for (var g = 0, L = v.length - 1; g <= L; ) {
            var M = Math.floor((g + L) / 2), H = v.slice(0, M + 1).join(" ");
            p(H) <= l ? g = M + 1 : L = M - 1;
          }
          if (g === 0) {
            b = o - 1;
            continue;
          }
          w = v.slice(0, g).join(" "), m[0].splice(0, g);
        }
        u.push(w);
      }
      return O(T), u;
    }
  }, {
    key: "renderLine",
    value: function(e, t, o) {
      if (t === o.length - 1)
        return h.createElement(
          "span",
          { key: t },
          e
        );
      var n = h.createElement("br", { key: t + "br" });
      return e ? [h.createElement(
        "span",
        { key: t },
        e
      ), n] : n;
    }
  }, {
    key: "render",
    value: function() {
      var e = this, t = this.elements.target, o = this.props, n = o.children, c = o.ellipsis, l = o.lines, s = $(o, ["children", "ellipsis", "lines"]), p = this.state.targetWidth, O = this.getLines, x = this.renderLine, u = this.onTruncate, y = void 0, m = !!(t && p);
      return typeof window < "u" && m && (l > 0 ? y = O().map(x) : (y = n, u(!1))), delete s.onTruncate, delete s.trimWhitespace, h.createElement(
        "span",
        F({}, s, { ref: function(d) {
          e.elements.target = d;
        } }),
        h.createElement(
          "span",
          null,
          y
        ),
        h.createElement(
          "span",
          { ref: function(d) {
            e.elements.text = d;
          } },
          n
        ),
        h.createElement(
          "span",
          { ref: function(d) {
            e.elements.ellipsis = d;
          }, style: this.styles.ellipsis },
          c
        )
      );
    }
  }]), i;
}(S);
z.propTypes = {
  children: f.node,
  ellipsis: f.node,
  lines: f.oneOfType([f.oneOf([!1]), f.number]),
  trimWhitespace: f.bool,
  width: f.number,
  onTruncate: f.func
};
z.defaultProps = {
  children: "",
  ellipsis: "…",
  lines: 1,
  trimWhitespace: !1,
  width: 0
};
const I = U()(({ mode: a }) => ({
  root: {
    color: a === A.Dye ? N.main : void 0
  }
})), Z = (a) => {
  const { classes: i } = I();
  return /* @__PURE__ */ D.jsx(z, { ...a, className: i.root, "data-fabric-component": "Truncate" });
};
export {
  Z as T
};
//# sourceMappingURL=truncate-CcQmmlDo.mjs.map
